/* ^_^ */
export default {
	messages: {
		it: {
			splash: {
				continue: "Entra nel Business Club",
				welcome: "Benvenuto in",
				pay_one: "La nuova community di AS Roma che nasce con l’obiettivo di favorire il networking, stimolare sinergie di business e creare occasioni di crescita.",
				pay_two: "Da oggi la passione per lo sport diventa un motivo in più per fare business insieme!"
			},
			favorites: {
				intro: 'I "Preferiti" stanno arrivando',
				intro_2: "Stiamo completando gli ultimi ritocchi per questa funzionalità.",
				intro_3: "Torna a visitarla nelle prossime settimane!",
				no_content_gen: 'Non ci sono preferiti!',
				no_content_body_gen: 'Non hai ancora aggiunto nessun preferito! Puoi aggiungerli cliccando sui cuoricini che visualizzi nelle aziende e nelle bacheche',
				no_content: 'Non ci sono preferiti per questa categoria!',
				no_content_body: 'Non hai ancora aggiunto nessun preferito di questa tipologia',
				back: "Torna alla Home",
				all: 'Tutti i Preferiti',
				business: 'Aziende',
				offers: 'Offerte',
				videos: 'Video',
				other: 'Altro'
			},
			videos: {
				all: 'Tutti i video',
				bcevents: 'Eventi BC',
				most_pop: 'Più popolari'
			},
			menu: {
				Dashboard: "Home",
				CategoriesIndex: "Aziende",
				Offers: "Offerte",
				Videos: "Video",
				Favourites: "Preferiti",
				Messages: "Messaggi",
				MyOffers: "Le mie Offerte",
				MyCompany: "La mia Azienda",
				MyAccount: "Il mio Account",
				Logout: "Esci"
			},
			translation: {
				main: "Alcune traduzioni mancano!",
				body: "Puoi procedere utilizzando <strong>la traduzione automatica di Google Traduttore</strong> (potrai sempre modificare la tua scheda in un secondo momento)",
				body2: "In alternativa, puoi modificare manualmente il profilo <strong>inserendo le traduzioni.</strong>",
				edit: "Modifica il Form",
				continue: "Continua con Google",
				action: "Traduci con Google"
			},
			search: {
				none: "Nessuna azienda trovata. Hai utilizzato il nome corretto?",
				search: "Cerca:"
			},
			gen: {
				giorni: 'giorni',
				ore: 'ore',
				minuti: 'minuti',
				secondi: 'secondi',
				continue: "Continua",
				back: "Indietro",
				edit: "Modifica",
				save_edits: "Salva le Modifiche",
				cancel: "Cancella",
				search: "Cerca azienda...",
				dragupload: "Tascina qui il file...",
				upload_limit: "Carica un file inferiore a 4MB.",
				back_top: "Torna Su",
				website: "Sito Ufficiale",
				close: 'Chiudi',
				rights: 'Diritti degli Interessati',
				people: 'persone',
				soon: 'Presto Disponibile',
				contact: 'Contatti',
				terminiecondizioni: 'Termini e Condizioni',
				infoprivacy: 'Informativa Privacy',
				cookie: 'Cookie'
			},
			join: {
				privacy_approve: "Dichiaro",
				privacy_body: "di aver letto e compreso la ",
				marketing_tick: "Spunta",
				marketing_approve: " questa casella se vuoi ricevere notizie, informazioni e offerte speciali dall'AS Roma. Puoi annullare l'iscrizione in qualsiasi momento",
				welcome_message: "Benvenuto! Riempi il form e completa l'attivazione del tuo Premium Business Club account.",
				message_step_2: "Riempi le informazioni seguenti con le info della tua azienda e le tue info di contatto.",
				message_step_3: "Riempi le informazioni seguenti riguardo i servizi della tua azienda e le offerte riservate ai membri del Premium Business Club",
				business_info: "Informazioni Azienda",
				business_name: "Nome Azienda",
				business_category: "Categoria",
				password_confirm: "Ripeti la password",
				offers_members: "Offerte per i membri",
				wrong_key: "Il codice d'invito che stai utilizzando non è valido.",
				thank_1: "Grazie, le tue informazioni sono state correttamente aggiunte e saranno presto disponibili online!",
				thank_2: "Adesso, puoi effettuare l'accesso all'AS Roma Business Club.",
				waiting_message_1: "Grazie, la tua richiesta di iscrizione si è conclusa con successo.",
				waiting_message_2: "Avrai accesso alla piattaforma a partire da mercoledì 24 febbraio, alle ore 15:00",
				mandatory: "I campi contrassegnati da <strong>*</strong> sono obbligatori",
				button_1: "Continua con le info Aziendali",
				button_2: "Continua con i Servizi e le Offerte",
				button_3: "Concludi l'iscrizione",
				add_first_service: "Aggiungi un servizio!",
				add_nth_service: "Aggiungi un altro servizio!",
				add_first_offer: "Aggiungi la prima offerta!",
				add_nth_offer: "Aggiungi un'altra offerta!",
				click_here: "Clicca qui",
				use_preset: "per scegliere un preset",
				errors: {
					password_short: 'Inserisci una password di almeno 5 caratteri',
					username: "Inserisci un'username di almeno 5 caratteri",
					username_used: "La username scelta è già in uso",
					password_verify: "La password di verifica non corrisponde",
					business_name: "Inserisci il nome dell'azienda",
					category: "Seleziona una categoria",
					company_phone: "Inserisci il numero di telefono",
					company_about: "Inserisci la descrizione della tua azienda in Italiano e Inglese",
					company_contact_name: "Inserisci il nome del Referente",
					company_contact_surname: "Inserisci il cognome del Referente",
					company_contact_role: "Inserisci il ruolo aziendale del Referente",
					company_contact_email: "Inserisci l'email di contatto del Referente",
					company_contact_phone: "Inserisci il numero di telefono del Referente",
					service: "Inserisci il servizio, in Italiano e Inglese",
					offer_body: "Inserisci la descrizione dell'offerta, in Italiano e Inglese",
					company_company_profile_name: "Inserisci l'etichetta del file allegato in Italiano e Inglese",
					offer_title: "Inserisci il nome dell'offerta, in Italiano e Inglese",
					offer_name: "Inserisci il nome dell'offerta in Italiano e Inglese",
				}
			},
			users: {
				edit_info: "Modifica Informazioni",
				edit_pass: "Modifica Password",
				name: "Nome e Cognome",
				actual_pass: "Password attuale",
				new_pass: "Nuova password",
				confirm_pass: "Conferma password",
				update_pass: "Aggiorna Password",
				avatar: "Immagine Personale"
			},
			messages: {
				search: "Cerca conversazione...",
				write: "Scrivi il tuo messaggio...",
				title: "Seleziona una conversazione!",
				body: "Seleziona dalla colonna una delle conversazioni recenti, o cerca un'azienda a cui inviare un messaggio",
				title_empty: "Non c'è ancora nessun messaggio!",
				body_empty: "Cerca un'azienda a cui sei interessato per inviargli un messaggio!",
				unread: "Non Letto",
				already: "Hai già inviato {n} messaggi a questo utente!",
				suggests: "Contatti Suggeriti:",
				new_modal: {
					yourself: "Non puoi inviare un messaggio a te stesso!",
					name: "Il tuo nome:",
					email: "La tua e-mail:",
					business: "La tua Azienda <em>(opzionale)</em>:",
					missing_message: "Inserisci un messaggio",
					message: "Messaggio:",
					send: "Invia",
					thanks: "Grazie",
					thankyou_message: "il tuo messaggio a {name} {surname} è stato inviato",
					message_sent: "La tua richiesta è stata inviata!"
				}
			},
			login: {
				welcomeBanner: "Benvenuto nell'area riservata dell'AS Roma Business Club",
				welcomeBannerWait: "Se sei iscritto al <strong>Club</strong>, ti aspettiamo mercoledì 24 febbraio, alle ore 15:00!",
				button: "Accedi",
				lostPassword: "Ho dimenticato la mia password",
				joinText: "Vuoi entrare nel club? Iscriviti"
			},
			recovery: {
				title: "Recupera la tua password",
				message: "Per effettuare un recupero delle tue credenziali d'accesso è necessario riempire il form specificando l'email utilizzata in fase di iscrizione",
				actionText: "Inviami le istruzioni di recupero",
				backLogin: "Torna al Login",
				thankyou_message: "Controlla la tua casella e-mail; se l'indirizzo specificato è corretto avrai ricevuto le istruzioni per procedere al recupero delle tue credenziali",
				title_process: "Modifica la tua password",
				cta_process: "Modifica password",
				wrong_key: "Il codice di recupero che stai utilizzando non è valido.",
				confirm_new_pass: "La tua password è stata cambiata! Procedi al", // Login
			},
			user_overview: {
				active_offer: "Offerte Attive",
				favorites: "Preferiti",
				messages_left: "Messaggi Rimanenti",
				unlimited: "Vuoi messaggi illimitati?",
				upgrade: "Effettua l'upgrade",
				no_limit: "Il tuo account non ha limiti",
				expire: "La tua prova scadrà il {expire}",
				messages_reached: "Hai raggiunto il limite di messaggi che puoi inviare oggi.",
				isAdmin: "sei un admin"
			},
			blocks: {
				pop_offer: "Offerte Popolari",
				pop_offer_vall: "Vedi tutte le offerte",
				new_co: "Nuove Aziende",
				new_co_vall: "Vedi tutte le aziende"
			},
			offers: {
				offer: "Offerta",
				description_placeholder: "Descrizione dell'offerta",
				preset: "Seleziona un preset",
				dedicated: "Promo Dedicata",
				use_preset: "Usa un preset",
				title_placeholder: "Nome della Promo",
				name_placeholder: "Nome della Promo",
				expiration: "Scadenza",
				mine: "Le mie offerte",
				add_message: "Aggiungi Offerta",
				pending: "Offerte in attesa di approvazione",
				pending_text: "revisione in approvazione",
				pending_popup: "Le tue modifiche sono state salvate, Presto verranno approvate e saranno disponibili online!",
				request: "Richiedi Offerta",
				missing: {
					generic: 'Guarda tutte le '
				},
				missing_2: "Non ci sono offerte in scadenza!",
				missing_1: "Non ci sono offerte recenti!",
				missing_0: "Non ci sono offerte!",
				expiration: "Data di scadenza dell'offerta",
				new: 'Nuova Offerta',
				tabs: {
					new: "Più Recenti",
					all: "Tutte le Offerte",
					expiring: "In Scadenza",
					pop: "Popolari"
				}
			},
			businesses: {
				verified: 'Sponsor Ufficiale',
				back: 'Indietro',
				categories: "Categorie",
				num_business: "nessun azienda | {n} azienda | {n} aziende",
				my_company: "La mia Azienda",
				business: "Azienda",
				business_info: "Informazioni Aziendali",
				business_contact: "Contatto",
				business_contact_info: "Informazioni di Contatto",
				review_wait: "Le tue modifiche sono in revisione!",
				cat_of: "Aziende per {name}:",
				expire_on: "Scade il {expire}",
				none: "Non ci sono aziende in questa categoria, torna a visitarci",
				send_review: "Invia la revisione",
				new_title: "Nuove Aziende",
				woffer: "Aziende con Offerte",
				show_detail: 'Continua a leggere',
				hide_detail: 'Chiudi',
				detail: {
					name: "Nome",
					detail: "Dettagli {name}",
					category: "Categoria",
					services: "Servizi",
					service: "Servizio",
					phone: "Numero di telefono",
					email: "Email",
					about: "Descrizione dell'azienda",
					no_services: "Nessun servizio segnalato",
					company_profile: "File Allegato",
					company_profile_name: "Etichetta file Allegato",
					logo: "Logo",
					company_profile_download: "Scarica",
					contacts: "Contatti",
					send_message: "Invia Messaggio",
					no_contact: "Nessun contatto segnalato",
					website: "Website",
					no_website: "Nessun sito segnalato",
					contact_phone: "Numero di telefono del Referente",
					contact_name: "Nome Referente",
					contact_surname: "Cognome Referente",
					contact_role: "Ruolo del Referente",
					contact_email: "E-Mail Referente",
					contact_photo: "Foto del Referente",
				},
				all: "Tutte le Aziende",
				new: "Nuove",
				offers: "Con Offerte"
			}
		},
		en: {
			splash: {
				continue: "Continue to Business Club",
				welcome: "Welcome to the",
				pay_one: "The brand-new AS Roma Business Club aims to facilitate networking, promote synergy between businesses and create growth opportunities.",
				pay_two: "It's the place where passion for sport becomes another reason to do business together!"
			},
			favorites: {
				intro: 'Favourites are coming soon',
				intro_2: "We're currently putting the finishing touches to this functionality.",
				intro_3: "Please come back in the next few weeks!",
				no_content_gen: 'EN - Non ci sono preferiti!',
				no_content_body_gen: 'EN - Non hai ancora aggiunto nessun preferito! Puoi aggiungerli cliccando sui cuoricini che visualizzi nelle aziende e nelle bacheche',
				no_content: 'EN - Non ci sono preferiti per questa categoria!',
				no_content_body: 'EN - Non hai ancora aggiunto nessun preferito di questa tipologia',
				back: "Return home",
				all: 'All favourites',
				business: 'Companies',
				offers: 'Offers',
				videos: 'Videos',
				other: 'Other'
			},
			videos: {
				all: 'All videos',
				bcevents: 'BC Events',
				most_pop: 'Most popular'
			},
			menu: {
				Dashboard: "Home",
				CategoriesIndex: "Companies",
				Offers: "Offers",
				Videos: "Videos",
				Favourites: "Favourites",
				Messages: "Messages",
				MyOffers: "My offers",
				MyCompany: "My company",
				MyAccount: "My account",
				Logout: "Log out"
			},
			translation: {
				main: "Some translations are missing",
				body: "You may continue and we’ll use <strong>Google Translate to automatically fill-in the blanks</strong> for you (you can always change them at a later time).",
				body2: "Alternatively, you can go back and <strong>complete the translations yourself.</strong>",
				edit: "Edit Form",
				continue: "Continue with Google",
				action: "Translate with Google"
			},
			search: {
				none: "No company found. Did you type it correctly?",
				search: "Search:"
			},
			gen: {
				giorni: 'days',
				ore: 'hours',
				minuti: 'mins',
				secondi: 'secs',
				continue: "Continue",
				back: "Back",
				edit: "Make changes",
				save_edits: "Save changes",
				cancel: "Cancel",
				search: "Search company...",
				dragupload: "Drag file...",
				upload_limit: "Maximum file size 4MB.",
				back_top: "Back to top",
				website: "Official website",
				close: 'Close',
				rights: 'Rights of data subjects',
				people: 'favourites',
				soon: 'Coming Soon',
				contact: 'Contacts',
				terminiecondizioni: 'Terms and Conditions',
				infoprivacy: 'Privacy Policy',
				cookie: 'Cookie Policy'
			},
			join: {
				privacy_approve: "I confirm",
				privacy_body: "I read and understood the ",
				marketing_tick: "Tick here",
				marketing_approve: " if you’d like to receive news, information, and special offers from AS Roma. You can unsubscribe at any time",
				welcome_message: "Welcome! Fill out the form to activate your Business Club account.",
				message_step_2: "Fill in your company information and provide you contact details.",
				message_step_3: "Fill out the following fields regarding the services your company provides and its offers for Premium Business Club members",
				business_info: "Company information",
				business_name: "Company name",
				business_category: "Category",
				offers_members: "Member offers",
				password_confirm: "Repeat the password",
				wrong_key: "The invitation code you are using is not valid.",
				thank_1: "Thanks, your details have been successfully added and will soon be available online!",
				thank_2: "You can now access the AS Roma Business Club.",
				waiting_message_1: "Your account is correctly created.",
				waiting_message_2: "You will have access to the platform  from Wednesday, 24 February at 3 pm",
				mandatory: "Fields marked with <strong>*</strong> are mandatory",
				button_1: "Continue with company information",
				button_2: "Continue with services and offers",
				button_3: "Complete registration",
				add_first_service: "Add a service!",
				add_nth_service: "Add a another service!",
				add_first_offer: "Add your first offer!",
				add_nth_offer: "Add a another offer!",
				click_here: "Click Here",
				use_preset: "to use a preset",
				errors: {
					password_short: 'Your password must consist of at least five characters',
					username: "Your username must consist of at least five characters",
					password_verify: "The two passwords do not match",
					business_name: "Insert company name",
					username_used: "Username already taken.",
					category: "Select a category",
					company_phone: "Enter telephone number",
					offer_name: "Add offer name in English and Italian",
					company_about: "Enter company description, in English and Italian",
					company_contact_name: "Enter contact person name",
					company_contact_surname: "Enter contact person surname",
					company_contact_role: "Enter contact person job title, in English and Italian",
					company_contact_email: "Enter contact person email address",
					company_contact_phone: "Enter contact person telephone number",
					company_company_profile_name: "Add attachment label in English and Italian",
					service: "Insert Service, in English and Italian",
					offer_body: "Add offer description in English and Italian",
					offer_title: "Add offer title in English and Italian",
				}
			},
			users: {
				edit_info: "Change information",
				edit_pass: "Change password",
				name: "Name and Surname",
				actual_pass: "Current password",
				new_pass: "New password",
				confirm_pass: "Confirm password",
				update_pass: "Update password",
				avatar: "Profile Picture"
			},
			messages: {
				search: "Search conversation...",
				write: "Write your message...",
				title: "Select a conversation!",
				body: "Select a recent conversation from the list, or search for a company to message",
				title_empty: "No messages yet!",
				body_empty: "Search for a company you’re interested in and send them a message!",
				unread: "Unread",
				already: "You've already sent {n} messages to this user!",
				suggests: "Suggested Contacts:",
				new_modal: {
					yourself: "You can’t send a message to yourself!",
					name: "Your name:",
					email: "Your email address:",
					business: "Your company <em>(optional)</em>:",
					missing_message: "Enter a message",
					message: "Message:",
					send: "Send",
					thanks: "Thanks",
					thankyou_message: "Your message to {name} {surname} has been sent",
					message_sent: "Your request has been sent"
				}
			},
			login: {
				welcomeBannerWait: "You will have access to the platform from Wednesday, 24 February at 3 pm",
				welcomeBanner: "Welcome to the private area of AS Roma Business Club",
				button: "Log in",
				lostPassword: "I’ve forgotten my password",
				joinText: "Want to join the club? Sign up!"
			},
			recovery: {
				title: "Recover your password",
				message: "Please fill out the form using the email address you entered during registration in order to recover your log-in details",
				actionText: "Send me instructions on recovering my details",
				backLogin: "Back to log-in",
				thankyou_message: "Check your inbox. If you’ve entered the correct email address, you’ll have received instructions on how to recover your log-in details",
				title_process: "Change your password",
				cta_process: "Change password",
				wrong_key: "The recovery code you are using is not valid.",
				confirm_new_pass: "Your password has been changed! Proceed to ", // Login
			},
			user_overview: {
				active_offer: "Active offers",
				favorites: "Favourites",
				messages_left: "Messages remaining",
				unlimited: "Want unlimited messages?",
				upgrade: "Upgrade now",
				no_limit: "You have an unlimited account",
				expire: "Your trial will expire on {expire}",
				messages_reached: "You’ve reached your message limit for today.",
				isAdmin: "You’re an admin"
			},
			blocks: {
				pop_offer: "Most Popular Offers",
				pop_offer_vall: "See all offers",
				new_co: "New companies",
				new_co_vall: "See all companies",
			},
			offers: {
				offer: "Offer",
				description_placeholder: "Add offer description",
				preset: "Select a preset",
				dedicated: "Special promo",
				use_preset: "Use a preset",
				title_placeholder: "Special promo name",
				name_placeholder: "Promo name",
				expiration: "Expiry",
				mine: "My offers",
				add_message: "Add offer",
				pending: "Offer awaiting approval",
				pending_text: "Changes awaiting approval",
				pending_popup: "Your changes have been saved. They will be approved soon and will be available online straight after this!",
				request: "Request offer",
				expiration: "Offer expiration date",
				missing: {
					generic: 'Go to all the '
				},
				missing_2: "There aren't any expiring offers",
				missing_1: "Non ci sono offerte recenti!",
				missing_0: "Non ci sono offerte!",
				new: 'New Offer',
				tabs: {
					new: "Newest",
					all: "All offers",
					expiring: "Ending Soon",
					pop: "Most Popular"
				}
			},
			businesses: {
				verified: 'Official Sponsor',
				back: 'Back',
				categories: "Categories",
				num_business: "no company | {n} company | {n} companies",
				my_company: "My company",
				business: "Company",
				business_info: "Company information",
				business_contact: "Contact",
				business_contact_info: "Contact details",
				review_wait: "Your changes are being reviewed!",
				cat_of: "Companies by {name}:",
				expire_on: "Expires on {expire}",
				none: "No companies in this category. Try again later",
				send_review: "Send changes",
				new_title: "New Companies",
				woffer: "Companies with Offers",
				show_detail: 'Read all',
				hide_detail: 'Close',
				detail: {
					name: "Name",
					detail: "Details {name}",
					category: "Category",
					services: "Services",
					service: "Service",
					phone: "Telephone number",
					email: "Email",
					about: "Company description",
					company_profile_name: "Attachment Label",
					no_services: "No service selected",
					company_profile: "Attachment",
					company_profile_download: "Download",
					contacts: "Contact",
					send_message: "Send message",
					no_contact: "No contact selected",
					website: "Website",
					no_website: "No website selected",
					contact_phone: "Contact person phone number",
					contact_name: "Contact person name",
					contact_surname: "Contact person surname",
					contact_role: "Contact person job title",
					contact_email: "Contact person email",
					contact_photo: "Contact person photo",
				},
				all: "All companies",
				new: "Newest",
				offers: "With offers"
			}
		}
	}
};